module.exports = __webpack_public_path__ + "static/img/gpt22.5fa06331.jpg";